import BetweenRoundsPageComponent from './betweenRoundsPage.component';
export default BetweenRoundsPageComponent;
